<div class="wrapper">
    <ix-content-header width="100%"
        hasBackButton="false"
        headerTitle="Fleet List"
        headerSubtitle="View all devices in your fleet.">
    </ix-content-header>

    <app-fleet-list></app-fleet-list>
</div>  
 